// Auth endpoints: OAuth start + dev-mode helpers (gated by app_env).

import { authHeaders, call, handleUnauthorized } from './core';

export const authApi = {
  startGoogleLogin(returnTo: string) {
    const url = `/api/v1/auth/oauth/google/start?return_to=${encodeURIComponent(returnTo)}`;
    window.location.href = url;
  },

  /** STA-116 — needed by raw fetch streams (interpret-picked) which
   * bypass the ``call`` wrapper. */
  authHeaders,

  /** Mirror of the wrapper's 401 handling for raw fetch sites (SSE
   * streams in Reading.tsx). Caller must invoke this right after the
   * fetch resolves; if it returns true the page is about to navigate
   * and the caller should not bother parsing the body. */
  handleAuthFailure(status: number): boolean {
    return handleUnauthorized(status, /* authed */ true);
  },

  // Dev mode — only works when backend has app_env='development'.
  // SPA hides these UI affordances unless devStatus().enabled is true.
  devStatus: () =>
    call<{ enabled: boolean }>('/auth/dev/status', { auth: false }).catch(() => ({
      enabled: false,
    })),
  devLogin: (email: string, name: string) =>
    call<{
      access_token: string;
      user: { id: string; email: string | null; display_name: string | null; avatar_url: string | null; stardust: number };
    }>('/auth/dev/login', {
      method: 'POST',
      body: JSON.stringify({ email, name }),
      auth: false,
    }),
  devGrantPremium: (days = 30) =>
    call<{ user_id: string; subscription_status: string; subscription_period_end: string | null; billing_provider: string | null }>(
      '/auth/dev/grant-premium',
      { method: 'POST', body: JSON.stringify({ days }) },
    ),
  devRevokePremium: () =>
    call<{ user_id: string; subscription_status: string }>(
      '/auth/dev/revoke-premium',
      { method: 'POST', body: JSON.stringify({}) },
    ),
};
